import { render, staticRenderFns } from "./travelCreate.vue?vue&type=template&id=2dd3e423&scoped=true&lang=html&"
import script from "./travelCreate.vue?vue&type=script&lang=js&"
export * from "./travelCreate.vue?vue&type=script&lang=js&"
import style0 from "./travelCreate.vue?vue&type=style&index=0&id=2dd3e423&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd3e423",
  null
  
)

export default component.exports